import { PendingApplicationView } from '../components/PendingApplicationView';
import { useQuery } from '@apollo/client';
import {
  GetViewerProgramEnrollmentsWithApplicationDocument,
  ProgramApplicationStatus,
} from '@sandtech-hub-monorepo/ehub-client';
import { useRefetchOnPageFocus } from '@sandtech-hub-monorepo/ui-kit';
import { ApprovedApplicationView } from '../components/ApprovedApplicationView';
import { getDisplayableEnrollments } from '../utils';

export const HomeEnrolled = () => {
  const { data, refetch } = useQuery(
    GetViewerProgramEnrollmentsWithApplicationDocument,
    {}
  );

  useRefetchOnPageFocus(refetch);

  const enrollments = getDisplayableEnrollments(
    data?.viewer.programEnrollments ?? []
  );

  return (
    <div className="h-full pt-8 px-6 pb-12 sm:pt-16 flex flex-col gap-8 max-w-screen-2xl mx-auto">
      <div className="flex justify-between items-center font-bold text-2xl text-heading">
        Current Programs
      </div>
      {enrollments.map((enrollment) => {
        const application = enrollment.programApplication ?? undefined;
        const isPending =
          application &&
          application.status !== ProgramApplicationStatus.Success;
        return isPending ? (
          <PendingApplicationView
            key={enrollment.id}
            enrollment={enrollment}
            application={application}
          />
        ) : (
          <ApprovedApplicationView
            key={enrollment.id}
            enrollment={enrollment}
            application={application}
          />
        );
      })}
    </div>
  );
};
